import FamilyRecordsModule from '../components/FamilyRecordsModule'

export default function Shopping(){
 return <FamilyRecordsModule module="shopping_items"/>
}
